export const setStickPoint = (s_height: number, c_height: number): number => {
  let stickPoint = 0
  if (s_height > c_height) {
    stickPoint = 0
  } else {
    const difference = c_height - s_height
    // console.log(difference, c_bottom, height);
    stickPoint = difference
  }
  return stickPoint
}

export const setStickPointString = (
  s_height: number,
  c_height: number,
): string => {
  let stickPoint = ''
  if (s_height > c_height) {
    stickPoint = '0px'
  } else {
    const difference = c_height - s_height
    // console.log(difference, c_bottom, height);
    stickPoint = `-${difference}px`
  }
  return stickPoint
}
